import * as React from 'react';
import DocumentTitle from 'react-document-title';

import { AccountingPageHeader } from '../components/accounting/accounting-page-header';
import { Revenue } from '../components/accounting/revenue';

export const AccountingRevenuePage: React.FC = () => (
    <DocumentTitle title="Accounting - Revenue">
        <div id="container">
            <AccountingPageHeader />
            <div id="content" className="flex-fill">
                <Revenue />
            </div>
        </div>
    </DocumentTitle>
);
